/**
 * @generated SignedSource<<73908f0278934cf4f1a19f479fa1f2ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPaneTitle_transaction$data = {
  readonly sku: {
    readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_sku">;
  } | null;
  readonly summary: {
    readonly invoiceSummary: {
      readonly buyerCurrentInvoice: {
        readonly totalAmount: {
          readonly " $fragmentSpreads": FragmentRefs<"CheckoutFormatAmount_financialAmount">;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSummaryItemSkuDetails_transaction">;
  readonly " $fragmentType": "CheckoutMobileSummaryPaneTitle_transaction";
};
export type CheckoutMobileSummaryPaneTitle_transaction$key = {
  readonly " $data"?: CheckoutMobileSummaryPaneTitle_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPaneTitle_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPaneTitle_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TransactionSummaryObject",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceSummary",
          "kind": "LinkedField",
          "name": "invoiceSummary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Invoice",
              "kind": "LinkedField",
              "name": "buyerCurrentInvoice",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "totalAmount",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CheckoutFormatAmount_financialAmount"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImageMultiSkuOverlay_sku"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "5a4e12d60b73b7a175f4667c07f2bbc9";

export default node;
